import { FhsAxios } from "../../services/axios";
export const Money_MODULE = {
  state: {
    money: null,
    moneyDetails: null
  },
  getters: {
    getMoneyData: state => state.money || {},
    getMoneyDataByCurrency: (state, getters) =>
      getters.getMoneyData[getters.getSelectedCurrency] || {},
    getMoneyDataByCurrencyGiven: (state, getters) => currency =>
      getters.getMoneyData[currency] || {},
    getMoneyDataTotalMoney: (state, getters) => {
      let total = getters.getMoneyDataByCurrency;
      return parseFloat(total["moneyFree"]) + parseFloat(total["moneyBlocked"]);
    },

    getMoneyDetails: state => state.moneyDetails || [],
    getMoneyDetailsFormatted: (state, getters) => {
      return {
        currency: getters.getSelectedCurrency,
        totalAmount: getters.getMoneyDataTotalMoney,
        currencySign: getters.getSelectedCurrencySign,
        cashData: getters.getMoneyDetails.map(detail => {
          let money_info = detail["MONEY"][getters.getSelectedCurrency];
          return {
            category: detail["CURRENCY"],
            value:
              parseFloat(money_info["FREE_AMOUNT"]) +
              parseFloat(money_info["BLOCKED_AMOUNT"])
          };
        })
      };
    },
    getMoneyForPortfolioChart: (state, getters) => {
      let money_data = getters.getMoneyDataByCurrency || {};
      return [
        {
          category: "Денежные средства",
          value:
            parseFloat(money_data["moneyFree"] || 0) +
            parseFloat(money_data["moneyBlocked"] || 0)
        },
        {
          category: "Обратное Репо",
          value: parseFloat(money_data["moneyRepo"] || 0)
        },
        {
          category: "Депозиты",
          value: parseFloat(money_data["moneyDepositSum"] || 0)
        }
      ];
    },
    getMoneyDataLoading: state =>
      state.money === null || state.moneyDetails === null
  },
  mutations: {
    setMoneyDetails: (state, payload) => (state.moneyDetails = payload),
    setMoneyData: (state, payload) => (state.money = payload)
  },
  actions: {
    fetchFinancialDetails({ getters, commit }) {
      commit("setMoneyDetails", null);
      commit("setMoneyData", null);
      let portfolio_id =
        getters.selectedPortfolio === "all"
          ? ""
          : "/" + getters.selectedPortfolio || "";
      return FhsAxios.get(`user/financial-data${portfolio_id}`).then(res => {
        if (res.data.status) {
          commit("setMoneyDetails", res.data.result.moneyDetails);
          commit("setMoneyData", res.data.result.money);
          return Promise.resolve(res.data.result);
        } else {
          commit("setMoneyDetails", null);
          commit("setMoneyData", null);
          return Promise.reject(res.data.result);
        }
      });
    }
  }
};
